import Slider from 'material-ui/Slider';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { formatHours, formatMinutes, pluralizeDays } from 'src/components/misc/redux-form-helpers';

class OtherSettings extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            defaultTaskPreProcessingTime: props.defaultTaskPreProcessingTime,
            defaultTaskPostProcessingTime: props.defaultTaskPostProcessingTime,
            bookingLeadTime: props.bookingLeadTime,
            bookingInAdvanceDays: props.bookingInAdvanceDays,
        };
    }

    handleDefaultTaskPreProcessingTimeSlider(event, value) {
        this.setState({ defaultTaskPreProcessingTime: value });
    }

    handleDefaultTaskPostProcessingTimeSlider(event, value) {
        this.setState({ defaultTaskPostProcessingTime: value });
    }

    handleBookingLeadTimeSlider(event, value) {
        this.setState({ bookingLeadTime: value });
    }

    handleBookingInAdvanceDaysSlider(event, value) {
        this.setState({ bookingInAdvanceDays: value });
    }

    componentDidUpdate(prevProps, prevState) {
        this.props.updateSettings(this.state);
    }

    render() {
        const {
            defaultTaskPreProcessingTime,
            defaultTaskPostProcessingTime,
            bookingLeadTime,
            bookingInAdvanceDays,
            t,
        } = this.props;

        return (
            <div className="other-settings">
                <div>
                    <p>
                        {t('companies.default_task_pre_processing_time', {
                            value: formatMinutes(t, this.state.defaultTaskPreProcessingTime),
                        })}
                    </p>
                    <Slider
                        min={0}
                        max={720}
                        step={5}
                        defaultValue={defaultTaskPreProcessingTime}
                        value={this.state.defaultTaskPreProcessingTime}
                        onChange={this.handleDefaultTaskPreProcessingTimeSlider}
                    />
                </div>
                <div>
                    <p>
                        {t('companies.default_task_post_processing_time', {
                            value: formatMinutes(t, this.state.defaultTaskPostProcessingTime),
                        })}
                    </p>
                    <Slider
                        min={0}
                        max={720}
                        step={5}
                        defaultValue={defaultTaskPostProcessingTime}
                        value={this.state.defaultTaskPostProcessingTime}
                        onChange={this.handleDefaultTaskPostProcessingTimeSlider}
                    />
                </div>
                <div>
                    <p>{t('companies.booking_lead_time', { value: formatHours(t, this.state.bookingLeadTime) })}</p>
                    <Slider
                        min={48}
                        max={240}
                        step={1}
                        defaultValue={bookingLeadTime}
                        value={this.state.bookingLeadTime}
                        onChange={this.handleBookingLeadTimeSlider}
                    />
                </div>
                <div>
                    <p>
                        {t('companies.bookingInAdvanceDays', {
                            value: pluralizeDays(t, this.state.bookingInAdvanceDays),
                        })}
                    </p>
                    <Slider
                        min={365}
                        max={1095}
                        step={1}
                        defaultValue={bookingInAdvanceDays}
                        value={this.state.bookingInAdvanceDays}
                        onChange={this.handleBookingInAdvanceDaysSlider}
                    />
                </div>
            </div>
        );
    }
}

export default OtherSettings;
